export const BUDGET_UPDATED_EVENT = 'klinvia:budget-updated';

export type BudgetUpdatedDetail = {
  budgetId?: string | null;
  patientId?: string | null;
};

export function dispatchBudgetUpdated(detail: BudgetUpdatedDetail) {
  window.dispatchEvent(new CustomEvent(BUDGET_UPDATED_EVENT, { detail }));
}

export function onBudgetUpdated(
  handler: (detail: BudgetUpdatedDetail) => void,
): () => void {
  const listener = (event: Event) => {
    handler((event as CustomEvent<BudgetUpdatedDetail>).detail || {});
  };
  window.addEventListener(BUDGET_UPDATED_EVENT, listener);
  return () => window.removeEventListener(BUDGET_UPDATED_EVENT, listener);
}
